import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Skeleton} from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
	skeletonCard: {
		background: '#fff',
		borderRadius: 12,
		overflow: 'hidden',
		boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
		position: 'relative',
		height: '100%',
		maxHeight: '330px',
	},
	skeletonImageWrapper: {
		position: 'relative',
		width: '100%',
		paddingTop: '100%', // 1:1 aspect ratio for square image
		backgroundColor: '#f5f5f5',
	},
	skeletonImage: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
	},
	skeletonDiscountBadge: {
		position: 'absolute',
		top: 8,
		left: 8,
	},
	skeletonBrandLogo: {
		position: 'absolute',
		top: 8,
		right: 8,
	},
	skeletonContent: {
		padding: theme.spacing(1),
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing(1),
	},
	skeletonTitleRow: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
		gap: theme.spacing(0),
	},
	skeletonPriceRow: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginTop: theme.spacing(1),
		gap: theme.spacing(1),
	},
}));

const ProductSkeleton = ({cartType = 'normal'}) => {
	const classes = useStyles();

	return (
		<div className={classes.skeletonCard}>
			{/* Image Section with Badge and Brand Logo */}
			<div className={classes.skeletonImageWrapper}>
				{/* Main Product Image */}
				<Skeleton
					variant="rect"
					className={classes.skeletonImage}
					animation="wave"
				/>
				{/* Discount Badge (top-left corner) */}
				<div className={classes.skeletonDiscountBadge}>
					<Skeleton
						variant="rect"
						width={60}
						height={24}
						animation="wave"
						style={{borderRadius: 4}}
					/>
				</div>

				{/* Brand Logo (top-right corner) */}
				<div className={classes.skeletonBrandLogo}>
					<Skeleton
						variant="circle"
						width={40}
						height={40}
						animation="wave"
					/>
				</div>
			</div>

			{/* Content Section */}
			<div className={classes.skeletonContent}>
				{/* Title Row with Favorite Button */}
				<div className={classes.skeletonTitleRow}>
					<div style={{flex: 1}}>
						{/* Product Title */}
						<Skeleton
							variant="text"
							width="100%"
							height={24}
							animation="wave"
						/>
						{/* Brand Name */}
						<Skeleton
							variant="text"
							width="60%"
							height={20}
							animation="wave"
							style={{marginTop: 4}}
						/>
					</div>
					{/* Favorite Button */}
					<Skeleton
						variant="circle"
						width={32}
						height={32}
						animation="wave"
					/>
				</div>

				{/* Country Flag */}
				<Skeleton
					variant="rect"
					width={30}
					height={20}
					animation="wave"
					style={{borderRadius: 4}}
				/>

				{/* Price and Button Row */}
				<div className={classes.skeletonPriceRow}>
					{/* Price */}
					<Skeleton
						variant="text"
						width={80}
						height={36}
						animation="wave"
					/>
					{/* Buy Button */}
					<Skeleton
						variant="rect"
						width={100}
						height={35}
						animation="wave"
						style={{borderRadius: 8}}
					/>
				</div>
			</div>
		</div>
	);
};

export default ProductSkeleton;